import MainModal from '../utils/MainModal';
import useAutoformMetadata from './hooks/useAutoformMetadata';
import AutoformTabs from './AutoformTabs';
import AutoformTableContainer from './AutoformTableContainer';

const EditChildTablesModal = ({ parentTableId, header, onClose }) => {
    const { metadata, hierarchicalTables } = useAutoformMetadata();

    return (
        <MainModal
            isOpen
            onClose={onClose}
            header={header}
            content={
                <AutoformTabs
                    renderTabPanel={(subTable) => (
                        <AutoformTableContainer schemaCode={metadata.schemaCode} tableId={subTable.id} />
                    )}
                    tables={hierarchicalTables.level4.filter((t) => t.parentId === parentTableId)}
                ></AutoformTabs>
            }
            secondaryButton={<></>}
            footerRightSlot={<></>}
        />
    );
};

export default EditChildTablesModal;
